import { Alert } from 'antd'
import React from 'react'

import type { InvoiceDetail } from '../../../../api/useFreight/types'
import type { TransactionDetail } from '../../../../api/useFreight/types'

export function StatusBanner({ details }: { details: TransactionDetail[] | InvoiceDetail[] }) {
  const hasNeedsApproval = details.some((detail) => detail.status === 'needs_approval')
  const hasErrors = details.some((detail) => detail.status === 'error')
  if (hasNeedsApproval) {
    return <Alert message='Needs Attention. Some accessorials need approval.' type='warning' showIcon />
  }
  if (hasErrors) {
    return (
      <Alert message='Rates Not Found. Some transactions could not find rates for freight.' type='error' showIcon />
    )
  }
  return null
}
